import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

enum EBadgeBackgroundColors {
  'success' = 'bg-[#d9fbd0] text-[#1c6c09] border-[#bee8b4] dark:bg-[rgba(144,214,127,0.08)] dark:text-[#90d67f] dark:border-[rgba(144,214,127,0.2)]',
  'info' = 'bg-[#c7ebff] text-[#005585] border-[#96d9ff] dark:bg-[rgba(96,198,255,0.08)] dark:text-[#60c6ff] dark:border-[rgba(96,198,255,0.2)]',
  'warning' = 'bg-[#ffefca] text-[#bc3803] border-[#ffcc85] dark:bg-[rgba(255,204,133,0.08)] dark:text-[#ffcc85] dark:border-[rgba(255,204,133,0.2)]',
  'danger' = 'bg-[#ffe0db] text-[#b81800] border-[#fabcb3] dark:bg-[rgba(244,130,112,0.08)] text-[#f48270] dark:border-[rgba(244,130,112,0.2)]',
  'disabled' = 'bg-[#e3e6ed] text-[#141824] border-[#cbd0dd] dark:bg-[rgba(49,55,74,0.08)] dark:text-[#7d899b] dark:border-[rgba(203,208,221,0.2)]',
  'violet' = 'bg-chart-violet bg-opacity-20 text-chart-violet border-chart-violet',
  'green-light' = 'bg-chart-green-light bg-opacity-20 text-chart-green-light border-chart-green-light',
  'green-dark' = 'bg-chart-green-dark bg-opacity-20 text-chart-green-dark border-chart-green-dark',
  'green' = 'bg-chart-green bg-opacity-20 text-chart-green border-chart-green',
  'blue' = 'bg-chart-blue bg-opacity-20 text-chart-blue border-chart-blue',
  'orange' = 'bg-chart-orange bg-opacity-20 text-chart-orange border-chart-orange',
  'red' = 'bg-chart-red bg-opacity-20 text-chart-red border-chart-red',
  'pink' = 'bg-chart-pink bg-opacity-20 text-chart-pink border-chart-pink',
  'purple' = 'bg-chart-purple bg-opacity-20 text-chart-purple border-chart-purple',
  'gray-light' = 'bg-chart-gray-light bg-opacity-20 text-chart-gray-light border-chart-gray-light',
}

@Component({
    selector: 'lib-badge-old',
    templateUrl: './badge.old.component.html',
    imports: [
        NgClass,
    ]
})
export class BadgeOldComponent {
  badgeBackgroundColor = EBadgeBackgroundColors;
  @Input() text = '';
  @Input() flatIcon = '';
  @Input() color: keyof typeof EBadgeBackgroundColors = 'success';
}
